export var CardExpirationStatus;
(function (CardExpirationStatus) {
    CardExpirationStatus["Active"] = "Active";
    CardExpirationStatus["ExpiringSoon"] = "ExpiringSoon";
    CardExpirationStatus["Expired"] = "Expired";
})(CardExpirationStatus || (CardExpirationStatus = {}));
export const getCardExpirationStatus = (cardExpiry, expiringSoonThresholdInMonths) => {
    const { expiryMonth, expiryYear } = cardExpiry;
    const today = new Date(Date.now());
    const currentMonth = today.getMonth() + 1;
    let currentYear = today.getFullYear();
    // Can't check the expiry status of a card with no expiry date.
    if (!expiryMonth || !expiryYear)
        return CardExpirationStatus.Active;
    // cardExpiryYear can be either 2 or 4 digits (e.g. 19 or 2019), while year will by default be 4 digits.
    if (expiryYear.toString().length === 2) {
        currentYear = Number.parseInt(currentYear.toString().substring(1), 10);
    }
    if (expiryYear < currentYear || (expiryYear === currentYear && expiryMonth < currentMonth)) {
        return CardExpirationStatus.Expired;
    }
    const differenceInMonths = 12 * (expiryYear - currentYear) - currentMonth + expiryMonth;
    if (differenceInMonths < expiringSoonThresholdInMonths) {
        return CardExpirationStatus.ExpiringSoon;
    }
    return CardExpirationStatus.Active;
};
